import { ElementMatcher } from './common/ElementMatcher';
const FAKE_PATH = 'fakepath';
const FAKE_PATH_SEPARATOR = '\\';
export class FileInput {
    constructor(win = window) {
        this.win = win;
    }
    activate() {
        this.win.document.addEventListener('change', (event) => {
            ElementMatcher.emittedByOrChild(event, '.control-file-input', (e) => this.handleFileInputChange(e));
        });
        this.win.document.addEventListener('reset', (event) => {
            ElementMatcher.emittedByOrChild(event, 'form', (e) => this.handleFormReset(e));
        });
    }
    handleFileInputChange(input) {
        const label = this.getFileInputLabel(input);
        if (!label)
            return;
        const selectedFiles = this.getSelectedFiles(input);
        if (selectedFiles.length) {
            if (label.dataset.filePlaceholder === undefined) {
                label.dataset.filePlaceholder = label.innerHTML;
            }
            label.innerHTML = selectedFiles;
        }
        else {
            this.restorePlaceholder(input);
        }
    }
    handleFormReset(form) {
        Array.from(form.querySelectorAll('.control-file-input'))
            .filter(element => element instanceof HTMLInputElement)
            .filter(input => this.restorePlaceholder(input));
    }
    getFileInputLabel(input) {
        if (!input.parentNode)
            return;
        const label = input.parentNode.querySelector('.control-file-label');
        return label && label instanceof HTMLElement
            ? label
            : undefined;
    }
    getSelectedFiles(input) {
        if (input.hasAttribute('multiple') && !!File) {
            return Array.from(input.files || [])
                .map(file => file.name)
                .join(', ');
        }
        if (input.value.indexOf(FAKE_PATH) !== -1) {
            const splittedValue = input.value.split(FAKE_PATH_SEPARATOR);
            return splittedValue[splittedValue.length - 1];
        }
        return input.value;
    }
    restorePlaceholder(input) {
        const label = this.getFileInputLabel(input);
        if (!label)
            return;
        label.innerHTML = label.dataset.filePlaceholder || '';
    }
}
